import { defineAction } from '~/prix'
import communityListAction from './communityList.action.json' with { type: 'json' }
import { communityObject } from '../communityObject'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'

export const communityExpression = expression(communityObject.shape)

const communityListDefinition = defineAction({
  ...communityListAction,

  input: z.object({
    filter: communityExpression.nullish(),
    limit: z.number().min(1).max(1000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      name: 'Nome',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({ items: z.array(communityObject), count: z.number() }),
})

export default communityListDefinition
